/**
 * Detect whether an error message indicates an authentication / session expiry problem.
 * Used by both ConvexErrorBoundary and RouteErrorBoundary to auto-redirect to login.
 */
export function isAuthError(message: string | undefined | null): boolean {
  if (!message) return false;
  return (
    message.includes('Unauthenticated') ||
    message.includes('Not authenticated') ||
    message.includes('invalid_grant') ||
    message.includes('refresh_token')
  );
}
